import CameraConfigurationModal from './cameraConfigurationModalContainer';

export default CameraConfigurationModal;
